import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.avdl = languageMap["avro-idl"] = bracketIndenting()
